import React from "react";
import Figure from "react-bootstrap/Figure";
import { Nav, Navbar } from "react-bootstrap";
import { Link } from "react-router-dom";
import FigureImage from "react-bootstrap/FigureImage";
import Logo from "../assets/Logo.png";

const Navigation = () => {
  return (
    <Navbar
      expand="lg"
      className="nav-bar sticky-top navbar-dark logo-position"
      id="nav-styling"
      collapseOnSelect
    >
      <div className="pl-3 mt-2">
        <Link to="/" className="navbar-brand" id="nav-logo">
          <FigureImage src={Logo} alt="movie-browsing-logo" width="130" />
          <Figure className="font-weight-bold pt-2 pl-2"></Figure>
        </Link>
      </div>
      <Navbar.Toggle className="mr-2 nav-button" />
      <Navbar.Collapse className=" align-items-end flex-column nav-button">
        <Nav>
          <Nav.Item className="px-4">
            <Nav.Link as={Link} to="/NewReleases" href="/NewReleases" id="navLink">
              <h5>NEW RELEASES</h5>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item className="px-4">
            <Nav.Link as={Link} to="/PeopleWatching" href="/PeopleWatching" id="navLink">
              <h5>PEOPLE WATCHING</h5>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item className="px-4">
            <Nav.Link as={Link} to="/TopRated"  href="/TopRated" id="navLink" >
              <h5>TOP RATED</h5>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item className="px-4">
            <Nav.Link as={Link} to="/Genre" href="/Genre" id="navLink">
              <h5>GENRE</h5>
            </Nav.Link>
          </Nav.Item>
          <Nav.Item className="px-4" >
            <Nav.Link as={Link} to="/Search" href="/Search" id="navLink" >
              <h5>SEARCH</h5>
            </Nav.Link>
          </Nav.Item>
        </Nav>
      </Navbar.Collapse>
    </Navbar>
  );
};

export default Navigation;